/* 新水表 */

import request from '@/service/request'

/* 用水记录 新水表
*  */
export const pageNewWaterUseRecordApi = (params) => {
  return request.post('/handle/newWater/pageCurrentWaterUseRecord', params)
}

/* 绑定水表 新水表
*  @params {string} deviceId 水表码
*  @params {string} dormitoryRoomId 宿舍id
* */
export const bindNewWaterMeterApi = (params) => {
  return request.post('/handle/newWaterUseSet/bindWater', params)
}

/* 统一设置水水费 新水表
*  @params {string} newWaterId 水表码
* */
export const setWaterPriceApi = () => {
  return request.post('/handle/newWaterUseSet/propertySet')
}

/* 开启水表 新水表
*  @params {string} dormitoryRoomId 宿舍id
* */
export const turnOnNewWaterMeterApi = (params) => {
  return request.post('/handle/newWater/network/open', params)
}

/* 关闭水表 新水表
*  @params {string} dormitoryRoomId 宿舍id
* */
export const turnOffNewWaterMeterApi = (params) => {
  return request.post('/handle/newWater/network/close', params)
}

/* 被占用重置水表 新水表
*  @params {string} dormitoryRoomId 宿舍id
* */
export const resetNewWaterMeterApi = (roomId) => {
  return request.post(`/handle/newWaterUseSet/usageStatusReset/${roomId}`)
}
